export function paramCase(str) {
  if (str !== undefined && str !== null) {
    return str
      .toLowerCase()
      .replace(/\s+/g, '-')
      .replace(/[^a-z0-9-]/g, '');
  }
  return ''; // หรือจะส่งค่าว่างกลับไปก็ได้ ขึ้นอยู่กับความเหมาะสมของโปรแกรมของคุณ
}

export function snakeCase(str) {
  return str
    .toLowerCase()
    .replace(/\s+/g, '_')
    .replace(/[^a-z0-9_]/g, '');
}
